import React, { Component } from 'react'
import { Form } from 'react-bootstrap'

class DisplayItemDossierDataSettings extends Component {
    constructor(props) {
        super(props)
        this.state = {
            dossier_data:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.dossier_data
                    ? this.props.item.settings.dossier_data
                    : null,
            display_name_style:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.display_name_style
                    ? this.props.item.settings.display_name_style
                    : null,
        }
    }

    render() {
        const kedo = this.props.kedo

        let defDossierId = this.state.block_data
            ? this.state.block_data.def_dossier_id
            : null

        return (
            <div>
                <Form.Group>
                    <Form.Label>{kedo.t('Dossier data')}</Form.Label>
                    <Form.Control
                        name={'dossier_data'}
                        onChange={(e) => {
                            this.setState({ dossier_data: e.target.value })
                            this.props.onChange('dossier_data', e.target.value)
                        }}
                        value={this.state.dossier_data}
                        as={'select'}
                    >
                        <option value={''}>{kedo.t('Choose an option')}</option>
                        <option value={'created_by'}>
                            {kedo.t('Created by')}
                        </option>
                        <option value={'modified_by'}>
                            {kedo.t('Modified by')}
                        </option>
                        <option value={'created_at'}>
                            {kedo.t('Created at')}
                        </option>
                        <option value={'modified_at'}>
                            {kedo.t('Modified at')}
                        </option>
                        <option value={'dossier_id'}>
                            {kedo.t('Dossier id')}
                        </option>
                    </Form.Control>
                    <br />
                    <Form.Label>{kedo.t('Display name style')}</Form.Label>
                    <Form.Control
                        as="select"
                        onSelect={this.state.default_current_user === true}
                        id={'display_name_style'}
                        value={this.state.display_name_style}
                        onChange={(e) => {
                            this.setState({
                                display_name_style: e.target.value,
                            })
                            this.props.onChange(
                                'display_name_style',
                                e.target.value
                            )
                        }}
                    >
                        <option value="default">Default</option>
                        <option value="avatar">Avatar</option>
                        <option value="both">Both</option>
                    </Form.Control>
                </Form.Group>
            </div>
        )
    }
}

export default DisplayItemDossierDataSettings
